import { QueryClient } from '@tanstack/react-query';

/**
 * Shared TanStack Query client.
 *
 * Exported as a singleton so non-React code (stores, imperative session
 * transitions) can call `queryClient.clear()` on logout/login without
 * reaching into a React context.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: any) => {
        // Don't retry on 4xx errors (client errors like 403 Forbidden).
        // Only retry on network errors and 5xx server errors.
        if (error?.message?.includes('403') || error?.message?.includes('401') || error?.message?.includes('404')) {
          return false;
        }
        return failureCount < 3;
      },
    },
  },
});
